var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-navigation"},[(_vm.isLoading)?_c('VProgressLinear',{attrs:{"indeterminate":""}}):_vm._e(),(!_vm.isLoading)?_c('SrNavigationBar',{attrs:{"items":_vm.sideNavigationViewModel.getNavigationItems()}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }